export const SquareAdd = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 6.00001H6C5.44771 6.00001 5 6.44772 5 7.00001V27C5 27.5523 5.44772 28 6 28H26C26.5523 28 27 27.5523 27 27V17" stroke="currentColor" stroke-width="2"/>
<path d="M20 8.00001H30" stroke="currentColor" stroke-width="2"/>
<path d="M25 2.99998L25 13" stroke="currentColor" stroke-width="2"/>
</svg>`;
